import { INode } from "../../@types/device";
import { ServiceContextType } from "../../@types/service";
import { asArray, readValue } from "../../lib/node";

/** One or more numeric values, big. Covers both temperature and battery. */
export default function Readout({
  node,
  ctx,
}: {
  node: INode;
  ctx: ServiceContextType;
}) {
  const reads = asArray(node.reads);
  if (!reads.length)
    return <div className="mt-4 text-sm opacity-40">No readings configured.</div>;

  return (
    <div className="flex flex-row justify-around mt-4">
      {reads.map((r, i) => {
        const v = readValue(ctx, r, node.addr);
        return (
          <div key={i}>
            <div className="flex flex-row justify-center">
              <div className="text-6xl">{v ?? "--"}</div>
              {r.unit && <div className="text-3xl font-light">{r.unit}</div>}
            </div>
            {r.label && (
              <div className="text-center text-sm opacity-50">{r.label}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
